import React from "react";

import { Icons } from "@/styles";
import Svg from "@/styles/utils/Svg";
import { colors } from "@/styles/Variants";

import * as Styled from "./styles";

export type TextFieldProps = {
  label: string;
  name: string;
  onChange: (value: string) => void;
  value: string;
  type?: string;
  autocomplete?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
};

const TextField: React.FC<TextFieldProps> = ({
  label,
  name,
  onChange,
  value,
  type = "text",
  autocomplete = "off",
  disabled = false,
  error = false,
  errorMessage,
}: TextFieldProps): React.JSX.Element => {
  return (
    <Styled.TextField>
      <Styled.InputWrapper>
        <Styled.Input
          data-qa="TextField"
          type={type}
          name={name}
          id={name}
          placeholder=" "
          autoComplete={autocomplete}
          onChange={(e) => onChange(e.target.value || "")}
          value={value}
          disabled={disabled}
          $error={error}
        />
        <Styled.Label htmlFor={name} $disabled={disabled} $error={error}>
          {label}
        </Styled.Label>
        {error && (
          <Styled.IconWrapper>
            <Svg
              contents={Icons.Warning}
              height={24}
              width={24}
              color={colors.bild.red500}
            />
          </Styled.IconWrapper>
        )}
      </Styled.InputWrapper>
      {errorMessage && (
        <Styled.ErrorMessage data-qa="TextField.Error.Message" $error={error}>
          {errorMessage}
        </Styled.ErrorMessage>
      )}
    </Styled.TextField>
  );
};

export default TextField;
